/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

// Component imports
import { Avatar, Checkbox, Space, Typography } from 'antd';
import { SmileOutlined } from '@ant-design/icons';

const LiveChatBotsFilter = ({
  id,
  bots,
  form,
  ...rest
}) => {
  const { t } = useTranslation();
  const [, updateState] = useState(); // Hook to force a component re-render

  return (
    <Fragment>
      <div className="border-bottom" style={{ marginLeft: -16, marginRight: -16 }}>
        <Checkbox
          className="mb-2 px-4"
          checked={!form.getFieldValue(id)?.length}
          onClick={() => {
            form.setFieldValue(id, []);
            updateState(id);
          }}
        >
          {t('All organization Agents')}
        </Checkbox>
      </div>

      <Checkbox.Group
        id={id}
        className="d-flex flex-column overflow-y-auto overflow-x-hidden px-5"
        style={{ maxHeight: 140 }}
        options={bots?.items.map(bot => (
          {
            label: (
              <Space wrap={false} align="center">
                <Avatar src={bot.image} size={20}>
                  <SmileOutlined className="d-inline v-align-baseline" />
                </Avatar>
                <Typography.Text ellipsis>
                  {bot.displayName}
                </Typography.Text>
              </Space>
            ),
            value: bot.id,
            style: { marginBottom: 4, marginTop: 4 }
          }
        ))}
        {...rest}
      />
    </Fragment>
  );
};

LiveChatBotsFilter.propTypes = {
  id: PropTypes.string,
  bots: PropTypes.object,
  form: PropTypes.object
};

export default LiveChatBotsFilter;
